import { useMemo } from 'react';
import { Category } from 'types/entity/category';
import { Tile } from '../../../types';

export const useFilteredTiles = (tiles: Tile[], currentCategory: Category | null) => {
  return useMemo(() => {
    if (!tiles || tiles.length === 0) return [];
    if (!currentCategory) return [];

    const getRootCategory = (category: Category): string | undefined => {
      if (category.depth === 0) {
        return category.categoryKey;
      }
      if (category.parentKey) {
        return category.parentKey;
      }
      return category.categoryKey;
    };

    const rootCategoryKey = getRootCategory(currentCategory);
    if (!rootCategoryKey) return tiles;

    return tiles.filter((tile) => tile.tileCategoryKey === rootCategoryKey);
  }, [tiles, currentCategory]);
};
